import Avatar0 from "../../../assets/avatars/Avatar0.jpg";
import Avatar1 from "../../../assets/avatars/Avatar1.jpg";
import Avatar2 from "../../../assets/avatars/Avatar2.jpg";
import Avatar3 from "../../../assets/avatars/Avatar3.jpg";
import Avatar4 from "../../../assets/avatars/Avatar4.jpg";
import Avatar5 from "../../../assets/avatars/Avatar5.jpg";
import Avatar6 from "../../../assets/avatars/Avatar6.jpg";
import Avatar7 from "../../../assets/avatars/Avatar7.jpg";
import Avatar8 from "../../../assets/avatars/Avatar8.jpg";
import Avatar9 from "../../../assets/avatars/Avatar9.jpg";
import Avatar10 from "../../../assets/avatars/Avatar10.jpg";
import Avatar11 from "../../../assets/avatars/Avatar11.jpg";
import Avatar12 from "../../../assets/avatars/Avatar12.jpg";
import Avatar13 from "../../../assets/avatars/Avatar13.jpg";
import Avatar14 from "../../../assets/avatars/Avatar14.jpg";
import Avatar15 from "../../../assets/avatars/Avatar15.jpg";
import Avatar16 from "../../../assets/avatars/Avatar16.jpg";
import Avatar17 from "../../../assets/avatars/Avatar17.jpg";
import Avatar18 from "../../../assets/avatars/Avatar18.jpg";
import Avatar19 from "../../../assets/avatars/Avatar19.jpg";
import Avatar20 from "../../../assets/avatars/Avatar20.jpg";
import Avatar21 from "../../../assets/avatars/Avatar21.jpg";
import Avatar22 from "../../../assets/avatars/Avatar22.jpg";
import Avatar23 from "../../../assets/avatars/Avatar23.jpg";

export const AVAILABLE_AVATARS = [
  "Avatar0", // default avatar
  ...Array.from({ length: 23 }, (_, i) => `Avatar${i + 1}`),
];

export const avatarImages = {
  Avatar0,
  Avatar1,
  Avatar2,
  Avatar3,
  Avatar4,
  Avatar5,
  Avatar6,
  Avatar7,
  Avatar8,
  Avatar9,
  Avatar10,
  Avatar11,
  Avatar12,
  Avatar13,
  Avatar14,
  Avatar15,
  Avatar16,
  Avatar17,
  Avatar18,
  Avatar19,
  Avatar20,
  Avatar21,
  Avatar22,
  Avatar23,
};
